import { useCallback, useEffect, useState } from "react";

function speakText(text) {
  if (!window.speechSynthesis || !text) return;
  window.speechSynthesis.cancel();
  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = "zh-CN";
  utter.rate = 0.95;
  window.speechSynthesis.speak(utter);
}

export default function VoiceReminderAlert() {
  const [alert, setAlert] = useState(null);

  const dismiss = useCallback(() => {
    window.speechSynthesis?.cancel?.();
    setAlert(null);
  }, []);

  useEffect(() => {
    const onFired = (e) => {
      const { title, body, id } = e.detail || {};
      setAlert({ title: title || "备忘提醒", body: body || "您有一条提醒", id });
    };
    window.addEventListener("voiceReminderFired", onFired);
    return () => window.removeEventListener("voiceReminderFired", onFired);
  }, []);

  useEffect(() => {
    if (!alert) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") dismiss();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [alert, dismiss]);

  if (!alert) return null;

  const replay = () => {
    speakText(`提醒时间到了，${alert.body}`);
  };

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/50"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="voice-reminder-alert-title"
    >
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl overflow-hidden animate-[fadeIn_0.2s_ease-out]">
        <div className="bg-gradient-to-r from-blue-500 to-indigo-500 px-6 py-5 text-white text-center">
          <div className="text-4xl mb-2">⏰</div>
          <h2 id="voice-reminder-alert-title" className="text-lg font-bold">
            {alert.title}
          </h2>
        </div>
        <div className="px-6 py-5">
          <p className="text-gray-800 text-center text-base leading-relaxed font-medium">
            {alert.body}
          </p>
          <div className="flex gap-3 mt-6">
            <button
              type="button"
              onClick={replay}
              className="flex-1 py-2.5 rounded-xl text-sm font-medium border border-blue-200 text-blue-600 hover:bg-blue-50"
            >
              再听一遍
            </button>
            <button
              type="button"
              onClick={dismiss}
              className="flex-1 py-2.5 rounded-xl text-sm font-medium bg-blue-500 text-white hover:bg-blue-600"
            >
              知道了
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export { speakText };
